<template>
  <div id="portal-app">
    <water-mark :content="watermarkText" v-if="showWaterMark"></water-mark>
    <Header v-if="showHeaderAndFooter"></Header>
    <LoginDialog></LoginDialog>
    <router-view id="router-view" v-web-title :data-title="webTitle" style="margin-top:72px;"></router-view>
    <!-- 子应用  -->
    <main id="subapp-container" v-web-title :data-title="webTitle"></main>
    <Footer v-if="showHeaderAndFooter"></Footer>
    <!-- AI 助手浮动入口 -->
    <div class="ai-float-wrapper" v-show="isLogin && !showAi && showAiAssistant">
      <!-- 角色形象 -->
      <div class="ai-character" @click="showAi=true">
        <img src="~@/common/img/ai.png" alt="AI助手">
        <div class="ai-character-tip" v-if="showAiTip">
          <span>Hi~ 需要帮助吗？</span>
          <i class="ai-character-tip-close" @click.stop="showAiTip=false"></i>
        </div>
      </div>
    </div>
    <!-- AI 对话抽屉面板 -->
    <el-drawer
      :visible.sync="showAi"
      direction="rtl"
      :with-header="false"
      :destroy-on-close="true"
      :modal="false"
      custom-class="ai-drawer"
      :close-on-press-escape="true"
      :wrapper-closable="true"
      :size="drawerSize"
    >
      <ai-drawer @close="showAi=false"></ai-drawer>
    </el-drawer>
  </div>
</template>

<script>
import { registerMicroApps, start, initGlobalState } from "qiankun";
import Header from "@/components/Header";
import LoginDialog from "@/components/LoginDialog";
import Footer from "@/components/Footer";
import WaterMark from "@/components/WaterMark";
import Api from "@/api/base";
import { getStorage, setStorage, removeStorage } from "@/common/js/localstorage";
import AiDrawer from "./AiDrawer";

export default {
  name: "AppHome",
  data() {
    return {
      apps: [],
      schoolId: 0,
      webTitle: "",
      showHeaderAndFooter: false,
      staticsHost: window.staticsHost,
      isLogin: Boolean(getStorage("user")) && getStorage("user") != " ",
      watermarkText: Boolean(getStorage("user")) && getStorage("user") != " " ? (getStorage("user").account + " " + getStorage("user").name) : "",
      showWaterMark: false,
      showAi: false,
      showAiTip: true,
      // 平台字典中是否存在 show_ai_assistant 开关，决定 AI 助手浮动入口是否展示
      showAiAssistant: false,
      debugMode: false,
      drawerSize: '650px'
    };
  },
  watch: {
    $route() {
      if (this.$route.fullPath.indexOf("ai_assistant") != -1) {
        this.webTitle = "AI循证教研助手";
      } else if (this.$route.fullPath.indexOf("micro/smart_sports/big_data") != -1 || this.$route.fullPath.indexOf("micro/smart_sports/new_big_data") != -1) {
        this.webTitle = "智慧体育-驾驶舱";
      } else if (this.$route.fullPath.indexOf("micro/smart_sports/digital_brain") != -1) {
        this.webTitle = "智慧体育-数字大脑";
      } else {
        this.webTitle = getStorage("school").title + (this.$route.name ? (' - ' + this.$route.name) : "");
      }
      this.setIcon(this.staticsHost + getStorage("school").icon_url);
      window.scrollTo(0, 0);
      // 调试：禁止路由登录检查
      if (!this.debugMode && ((window.UserMustLogin && !this.isLogin) || getStorage("user").state == 4) && this.$route.path != "/login") {
        window.open(window.location.origin + "/#/login", "_self");
      }
    },
  },
  created() {
    let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
    // 调试：禁止移动端跳转
    if (flag && !this.debugMode) {
      window.open(window.location.origin + "/wechat/#/", "_self");
    } else {
      this.getOrgInfo();
      this.getSchoolId();
      if (this.$route.fullPath.indexOf("ai_assistant") != -1) {
        this.webTitle = "AI循证教研助手";
      } else if (this.$route.fullPath.indexOf("micro/smart_sports/big_data") != -1 || this.$route.fullPath.indexOf("micro/smart_sports/new_big_data") != -1) {
        this.webTitle = "智慧体育-驾驶舱";
      } else if (this.$route.fullPath.indexOf("micro/smart_sports/digital_brain") != -1) {
        this.webTitle = "智慧体育-数字大脑";
      } else {
        this.webTitle = getStorage("school").title;
      }
      this.setIcon(this.staticsHost + getStorage("school").icon_url);
      // 调试：禁止登录跳转和主页跳转
      if (!this.debugMode && window.UserMustLogin && !this.isLogin) {
        if (window.CasClientLoginUrlAutoRedirect) {
          window.open(window.CasClientLoginUrl, "_self");
        } else {
          window.open(window.location.origin + "/#/login", "_self");
        }
      } else {
        if (!this.debugMode && getStorage("user").state == 4 && this.$route.path != "/login") {
          window.open(window.location.origin + "/#/login", "_self");
        } else if ((this.$route.path == "/" || this.$route.path == "/home") && this.isLogin) {
          window.open(getStorage("user").org_web_path, "_self");
          // 调试时需要将路由切换到本地
          // window.open("http://127.0.0.1:8889/#", "_self");
        }
        if (this.$route.fullPath.indexOf("ai_lesson_analysis") != -1 || this.$route.fullPath.indexOf("classroom_default_live") != -1 || this.$route.fullPath.indexOf("iot_gateway") != -1 || this.$route.fullPath.indexOf("agent_hub") != -1 || this.$route.fullPath.indexOf("chemistry_evaluation") != -1 || this.$route.fullPath.indexOf("agent_workbench") != -1 || this.$route.fullPath.indexOf("ai_assistant") != -1 || this.$route.fullPath.indexOf("micro/smart_sports/big_data") != -1 || this.$route.fullPath.indexOf("micro/smart_sports/digital_brain") != -1 || this.$route.fullPath.indexOf("login") != -1) {
          this.showHeaderAndFooter = false;
        }
      }
      if (this.$route.path.indexOf("wechat/livecloud") != -1) {
        window.open("https://" + window.location.hostname + "/wechat/#/livecloud", "_self")
      }
    }
    this.checkShowAiAssistant();
  },
  mounted() {
    this.getAppList();
    // 调试：禁止登录跳转
    if (!this.debugMode && window.UserMustLogin && !this.isLogin && this.$route.path != "/login") {
      if (window.CasClientLoginUrlAutoRedirect) {
        window.open(window.CasClientLoginUrl, "_self");
      } else {
        window.open(window.location.origin + "/#/login", "_self");
      }
    } else if (!this.debugMode && getStorage("user").state == 4 && this.$route.path != "/login") {
      window.open(window.location.origin + "/#/login", "_self");
    } else {
      this.$bus.$on('showHeaderAndFooter', content => {
        console.log("监听到通信传递了值：" + JSON.stringify(content));
        // 输出兄弟组件传递的内容
        if (content && this.$route.fullPath.indexOf("login") == -1) {
          this.showHeaderAndFooter = true;
          this.$router.go(0);
        }
      });
      //监听是否切换到当前标签页
      document.addEventListener('visibilitychange', this.handleVisiable);
      // Hi~ 提示 5s 后自动关闭
      setTimeout(() => { this.showAiTip = false; }, 5000);
      this.$bus.$on('showLogin', () => {
        if (window.CasClientLoginUrlAutoRedirect) {
          window.open(window.CasClientLoginUrl, "_self");
        } else {
          // window.open(window.location.origin + "/#/login", "_self");
        }
      })
      if ((this.$route.path == "/" || this.$route.path == "/home") && this.isLogin) {
        if (window.location.href.indexOf(getStorage("user").org_web_path) == -1) {
          window.open(getStorage("user").org_web_path, "_self");
          // 调试时需要将路由切换到本地
          // window.open("http://127.0.0.1:8889/#", "_self");
        }
      }
      if (this.isLogin && getStorage("user").area_type == 2) {
        this.getSchoolSetting();
      }
      if (this.$route.fullPath.indexOf("ai_lesson_analysis") != -1 || this.$route.fullPath.indexOf("classroom_default_live") != -1 || this.$route.fullPath.indexOf("ai_assistant") != -1 || this.$route.fullPath.indexOf("micro/smart_sports/big_data") != -1 || this.$route.fullPath.indexOf("micro/smart_sports/new_big_data") != -1 || this.$route.fullPath.indexOf("micro/smart_sports/digital_brain") != -1 || this.$route.fullPath.indexOf("login") != -1) {
        this.showHeaderAndFooter = false;
      }
    }
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  components: {
    Header,
    LoginDialog,
    Footer,
    WaterMark,
    AiDrawer
  },
  methods: {
    getSchoolId() {
      if (Boolean(getStorage("user")) && getStorage("user") != " ") {
        this.schoolId = getStorage("user").area_id;
      } else {
        this.schoolId = getStorage("school").org_id;
      }
    },
    // 根据平台字典判断是否需要展示 AI 助手浮动入口
    checkShowAiAssistant() {
      if (Boolean(getStorage("dictionary")) && getStorage("dictionary") != " ") {
        this.platformNameList = JSON.parse(getStorage("dictionary"));
        // 控制显示
        this.platformNameList.forEach(item => {
          if (item.key == "show_ai_assistant") {
            this.showAiAssistant = true;
          }
        })
      }
    },
    setIcon(url) {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = url;
      document.getElementsByTagName('head')[0].appendChild(link);
    },
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case 'prerender':
          console.log('网页预渲染，内容不可见')
          break;
        case 'hidden':
          console.log('内容不可见，处理后台、最小化、锁屏状态')
          break;
        case 'visible':
          console.log('处于正常打开')
          this.getOrgInfo();
          break;
      }
    },
    getOrgInfo() {
      let pathname = window.location.pathname;
      setStorage("pathname", pathname);
      Api.getOrgDetailByPathname(pathname).then((response) => {
        if (response.data.status === 0) {
          let school = response.data.data;
          setStorage("school", school);
        } else {
          console.log(response.data.info.message);
          //清除storage
          removeStorage("user");
          window.open(window.location.origin + "/#/login", "_self");
        }
      });
    },
    // 获取学校设置信息
    getSchoolSetting() {
      Api.getSchoolSetting(getStorage("user").area_id).then((response) => {
        if (response.data.status === 0) {
          this.showWaterMark = response.data.data.is_watermark == 1 ? true : false;
        } else {
          console.log(response.data.info.message);
        }
      });
    },
    async getAppList() {
      const container = "#subapp-container";
      if (document.getElementById("subapp-container")) {
        const data = getStorage("school").org_type === 1 ? { area_id: getStorage("school").org_id || 0 } : { school_id: getStorage("school").org_id || 0 };
        await Api.getSubappRegisterList(data).then((response) => {
          if (response.data.status === 0) {
            const list = response.data.data.list;
            for (let i = 0; i < list.length; i++) {
              this.apps.push({
                id: list[i].id,
                name: list[i].name,
                entry: list[i].entry,
                container,
                activeRule: window.location.pathname.substring(0, window.location.pathname.length - 1) + list[i].active_rule,
              });
            }
          }
        });
        this.initQiankun();
      }
    },
    //qiankun初始化加载子应用
    initQiankun() {
      /**
       * Step2 注册子应用
       */
      registerMicroApps(this.apps, {
        beforeLoad: [
          (app) => {
            console.log("[LifeCycle] before load %c%s", "color: green;", app.name);
          },
        ],
        beforeMount: [
          (app) => {
            console.log("[LifeCycle] before mount %c%s", "color: green;", app.name);
          },
        ],
        afterUnmount: [
          (app) => {
            console.log("[LifeCycle] after unmount %c%s", "color: green;", app.name);
          },
        ],
      });

      const { onGlobalStateChange, setGlobalState } = initGlobalState({
        user: "qiankun",
      });

      onGlobalStateChange((value, prev) => {
        console.log("[onGlobalStateChange - master]:", value)
        console.log("[onGlobalStateChange - master]:", prev)
        if (value.showLoginDialog && value.showLoginDialog == true) {
          window.open(window.location.origin + "/#/login", "_self");
        }
        if ((value.showHeaderAndFooter && value.showHeaderAndFooter == true) 
        && this.$route.fullPath.indexOf("ai_lesson_analysis") == -1 
        && this.$route.fullPath.indexOf("classroom_default_live") == -1 
        && this.$route.fullPath.indexOf("iot_gateway") == -1 
        && this.$route.fullPath.indexOf("agent_hub") == -1 
        && this.$route.fullPath.indexOf("chemistry_evaluation") == -1 
        && this.$route.fullPath.indexOf("agent_workbench") == -1 
        && this.$route.fullPath.indexOf("ai_assistant") == -1 
        && this.$route.fullPath.indexOf("micro/smart_sports/big_data") == -1 
        && this.$route.fullPath.indexOf("micro/smart_sports/digital_brain") == -1 
        && this.$route.fullPath.indexOf("login") == -1) {
          console.log("接收到显示header");
          this.showHeaderAndFooter = true;
          document.getElementById("subapp-container").style.marginTop = "72px";
        } else {
          console.log("接收到关闭header");
          this.showHeaderAndFooter = false;
          document.getElementById("subapp-container").style.marginTop = "0px";
        }
      });

      if (this.$route.path != "/login") {
        setGlobalState({
          ignore: "master",
          user: {
            name: "master",
          },
          showHeaderAndFooter: true
        });
      }

      start({
        prefetch: (app) => app.name === 'login'
      });

    },
  },
};
</script>

<style>
html,
body {
  padding: 0;
  margin: 0;
  height: 100vh;
}

#portal-app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #303133;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  position: relative;
}

.el-dropdown-menu__item {
  font-size: 16px !important;
  /* width: 100px; */
  text-align: center;
}

.header .center .el-input__inner {
  border-radius: 20px;
  border: 0;
  background: transparent;
  padding-left: 4em;
}

.header .center .el-input__prefix {
  left: 2em;
}

/* 表格背景颜色透明 */
.home .el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}

/* 表格背景颜色透明 */
.home .el-table tr {
  background-color: transparent !important;
  cursor: pointer;
}

/* 表格背景颜色透明 */
.notice .el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}

/* 表格背景颜色透明 */
.notice .el-table tr {
  background-color: transparent !important;
  cursor: pointer;
}

/* 鼠标移入样式 */
.home .el-table tr:hover {
  color: #569af8;
}

/* 鼠标移入样式 */
.notice .el-table tr:hover {
  color: #569af8;
}

/* 去掉表格边框 */
.home .middle .el-table td {
  border: 0;
}

/* 去掉默认存在的边线 */
.home .middle .el-table::before {
  height: 0;
}
#subapp-container {
  margin-top: 72px;
}
/* === AI 助手浮动入口 === */
.ai-float-wrapper {
  position: fixed;
  right: 45px;
  bottom: 100px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 角色形象 */
.ai-character {
  width: 80px;
  height: 80px;
  cursor: pointer;
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
  animation: ai-float 3s ease-in-out infinite;
}
/* 柔光底圈 */
.ai-character::before {
  content: '';
  position: absolute;
  inset: -10px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(53,139,252,0.18) 0%, rgba(53,139,252,0.06) 50%, transparent 70%);
  z-index: -1;
}
.ai-character:hover::before {
  background: radial-gradient(circle, rgba(53,139,252,0.28) 0%, rgba(53,139,252,0.1) 50%, transparent 70%);
}
.ai-character:hover {
  transform: scale(1.12);
  animation: none;
}
.ai-character img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  filter: drop-shadow(0 4px 20px rgba(0,0,0,0.15));
}
@keyframes ai-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

/* 角色提示气泡 */
.ai-character-tip {
  position: absolute;
  top: -48px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  background: rgba(80,80,80,0.92);
  color: #fff;
  font-size: 13px;
  padding: 6px 14px;
  border-radius: 8px;
  line-height: 20px;
  animation: ai-tip-in 0.3s ease;
}
.ai-character-tip::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid rgba(80,80,80,0.92);
}
.ai-character-tip-close {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-left: 8px;
  cursor: pointer;
  vertical-align: middle;
  position: relative;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.ai-character-tip-close:hover {
  opacity: 1;
}
.ai-character-tip-close::before,
.ai-character-tip-close::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 1.2px;
  background: #fff;
}
.ai-character-tip-close::before { transform: translate(-50%,-50%) rotate(45deg); }
.ai-character-tip-close::after { transform: translate(-50%,-50%) rotate(-45deg); }
@keyframes ai-tip-in {
  from { opacity: 0; transform: translateX(-50%) translateY(4px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
}

/* === AI 抽屉面板外框 === */
.ai-drawer {
  border-radius: 12px 0 0 12px;
  overflow: hidden;
}
.ai-drawer .el-drawer__body {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F5F7FB;
}
</style>
